import Grid from "@material-ui/core/Grid";
import { KeyboardEventHandler } from "react";
import { CraftsFilter } from "./craftsFilter";
import { DownHoursFilter } from "./downHoursFilter";
import { SearchFilter } from "./SearchFilter";
import { useInitialValues } from "./hooks/useInitialValues";
import { useSearchParamsToReducer } from "./hooks/useSearchParamsToReducer";
import { TypesFilter } from "./typesFilter";

type Props = {
	searchData: Function;
};

export const Filters = ({ searchData }: Props) => {
	useInitialValues();
	useSearchParamsToReducer({ searchData });

	return (
		<>
			<Grid item lg={3} md={12} xs={12}>
				<SearchFilter searchData={searchData} />
			</Grid>
			<Grid item lg={3} md={12} xs={12} style={{ marginTop: 4 }}>
				<CraftsFilter />
			</Grid>
			<Grid item lg={3} md={12} xs={12}>
				<DownHoursFilter searchData={searchData} />
			</Grid>
			<Grid item lg={3} md={12} xs={12} style={{ marginTop: -5 }}>
				<TypesFilter />
			</Grid>
		</>
	);
};
